const getMedian = (data: (null | number)[]): number => {
  const array = data.filter((v): v is number => v !== null).sort((a, b) => a - b);

  return array.length % 2 === 0
    ? (array[array.length / 2] + array[array.length / 2 - 1]) / 2
    : array[(array.length - 1) / 2];
};

export default getMedian;
